import React from "react";
import { MdArrowDownward, MdArrowUpward } from "react-icons/md";

/**
 * Estilos compartidos de tabla.
 *
 * Las tres tablas de la app (dashboard, activos, inactivos) repetían sus
 * propias clases y se habían desincronizado: encabezados con `text-gray-200`
 * (casi invisibles), celdas centradas contra encabezados alineados a la
 * izquierda y filas sin estado hover. Acá queda una sola definición.
 */

/** Fila del encabezado */
export const theadRowClass = "border-b border-gray-200 dark:border-white/10";

/** Celda del encabezado (clickeable para ordenar) */
export const thClass =
  "group cursor-pointer select-none px-3 pb-2.5 text-left align-bottom transition-colors hover:text-gray-900";

/** Rótulo del encabezado: chico, en mayúsculas y apagado. Los datos mandan. */
export const thLabelClass =
  "text-[11px] font-semibold uppercase tracking-[0.07em] text-gray-700 dark:text-gray-500";

/** Fila de datos */
export const trClass =
  "border-b border-gray-200/60 transition-colors duration-150 last:border-0 hover:bg-gray-50/70 dark:border-white/5 dark:hover:bg-white/[0.03]";

/** Celda de datos */
export const tdClass =
  "px-3 py-3 text-left align-middle text-sm text-gray-900 dark:text-white";

/** Celda de datos destacada (primera columna) */
export const tdStrongClass =
  "px-3 py-3 text-left align-middle text-sm font-semibold text-gray-900 dark:text-white";

/** Indicador de orden: sustituye a los caracteres ▲ / ▼ sueltos. */
export const SortIndicator: React.FC<{ direction: false | "asc" | "desc" }> = ({
  direction,
}) => {
  if (!direction) {
    return (
      <span className="inline-flex w-3.5 opacity-0 transition-opacity group-hover:opacity-40">
        <MdArrowUpward className="h-3.5 w-3.5" />
      </span>
    );
  }
  return (
    <span className="inline-flex w-3.5 text-brand-500 dark:text-brand-200">
      {direction === "asc" ? (
        <MdArrowUpward className="h-3.5 w-3.5" />
      ) : (
        <MdArrowDownward className="h-3.5 w-3.5" />
      )}
    </span>
  );
};
